// removed by extract-text-webpack-plugin
module.exports = {"eclipse":"#9e9fa5","inputWrapper":"ChatSearchBlock__inputWrapper___msdXH","closeButton":"ChatSearchBlock__closeButton___3Ww6U","closeGlyph":"ChatSearchBlock__closeGlyph___2fOlg","input":"ChatSearchBlock__input___27qUi","inputGlyph":"ChatSearchBlock__inputGlyph___3_tnl"};


//////////////////
// WEBPACK FOOTER
// ./src/chat/components/styles/ChatSearchBlock.css
// module id = 2198
// module chunks = 0 1